// src/components/Toast.js
import React, { useEffect, useState } from "react";
import "./Toast.css";
import oPlaced from "../Assets/oplaced.png";
import oError from "../Assets/onerror.png";
import oLogin from "../Assets/onlogin.png";
import oSuccess from "../Assets/onsuccess.png";
import Pending from "../Assets/OrderPending.svg";
import cross from "../Assets/cross.svg";

const Toast = ({
  id,
  title,
  message,
  type,
  buttonText,
  buttonClick,
  secondaryButtonText,
  secondaryButtonClick,
  onClose,
  duration = 10000,
}) => {
  const [isVisible, setIsVisible] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, duration - 1000); // Subtract a bit of time to start fade-out before closing

    const autoClose = setTimeout(() => {
      onClose(id);
    }, duration);

    return () => {
      clearTimeout(timer);
      clearTimeout(autoClose);
    };
  }, [id, onClose, duration]);
  const handleClose = () => {
    setIsVisible(false);
    setTimeout(() => {
      onClose(id);
    }, 1000);
    // onClose(id);
    // Allow fade-out animation to complete
  };
  const getImage = (type) => {
    switch (type) {
      case "order-placed":
        return oPlaced;
      case "error":
        return oError; // Assuming you want a different image for "error"
      case "login":
        return oLogin; // Assuming you want a different image for "login"
      case "success":
        return oSuccess; // Assuming you want a different image for "success"
      case "pending":
        return Pending; // Assuming you want a different image for "success"
    }
  };
  const handleButtonClick = () => {
    if (buttonClick) {
      buttonClick();
    }
    handleClose();
  };
  const handleButtonClickSecondary = () => {
    if (buttonClick) {
      secondaryButtonClick();
    }
    handleClose();
  };

  return (
    <div className={`toast ${type} ${isVisible ? "fade-in" : "fade-out"}`}>
      <div className="toast-content">
        <div className="toast-header-close">
          <div className="toast-header">
            <div className="toast-icon">
              <img src={getImage(type)} alt="image display" />
            </div>
            <div className="toast-title">
              <h3>{title}</h3>
            </div>
          </div>
          <div className="toast-header-close">
            <button className={"toast-close"} onClick={handleClose}>
              <img src={cross} alt="cross" />
            </button>
          </div>
        </div>
        <div className="toast-message">{message}</div>

        <div className="buttons">
          {buttonText && (
            <button className="toast-button" onClick={handleButtonClick}>
              {buttonText}
            </button>
          )}
          {secondaryButtonText && (
            <button className="reject" onClick={handleButtonClickSecondary}>
              {secondaryButtonText}
            </button>
          )}
        </div>
      </div>
      <div
        className="progress-bar"
        style={{ animationDuration: `${duration - 1007}ms` }}
      ></div>
    </div>
  );
};

export default Toast;
